import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { Autocomplete } from '@material-ui/lab'
import { TextField } from '@material-ui/core'

import useAuth from 'hooks/useAuth'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

const PartnerAuditForm = ({ control, errors, companySupplierId, setValue }) => {
  const { PROGRESS_STATUSES_LABEL } = constants.companySuppliers

  const { company } = useAuth()
  const snackbar = useSnackbar()

  const { response, isLoading, error } = useFetch(
    service.dponet.companies.showSupplierReportAudits,
    { companyId: company.id, companySupplierId },
    [companySupplierId],
  )

  const audits = response?.data?.companySupplier?.companySupplierAudits || []

  const auditOptions = audits.map((audit) => {
    const startDate =
      helpers.formatters.date(audit.dateToSendEmails) ||
      '[Data de inicio não informada]'
    const endDate =
      helpers.formatters.date(audit.endDate) || '[Prazo final não informado]'
    const progressLabel = PROGRESS_STATUSES_LABEL[audit.progressStatus]

    return {
      id: audit.id,
      name: `#${audit.id} • ${startDate} - ${endDate}${
        progressLabel ? ` • ${progressLabel}` : ''
      }`,
    }
  })

  useEffect(() => {
    setValue('auditId', null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySupplierId])

  useEffect(() => {
    if (!error) return

    snackbar.open({
      message:
        helpers.formatters.errorMessage(error?.response?.data?.error, false) ||
        'Falha ao buscar as auditorias do fornecedor.',
      variant: 'error',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return (
    <Controller
      as={
        <Autocomplete
          options={auditOptions}
          loading={isLoading}
          loadingText="Carregando..."
          getOptionLabel={(option) => option?.name || ''}
          getOptionSelected={(option, value) => option?.id === value?.id}
          noOptionsText="Nenhuma auditoria encontrada"
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!errors?.auditId}
              helperText={errors?.auditId?.message}
              fullWidth
              variant="outlined"
              label="Auditoria"
            />
          )}
        />
      }
      name="auditId"
      control={control}
      defaultValue={null}
      onChange={([, data]) => data}
      mode="onChange"
    />
  )
}

PartnerAuditForm.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  companySupplierId: PropTypes.number.isRequired,
  setValue: PropTypes.func.isRequired,
}

export default PartnerAuditForm
